import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Unit Plan Table (/unit-plan)
 */
export const unitPlanTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_UnitPlanTable_Welcome_Title"),
    description: t("Tour_UnitPlanTable_Welcome_Description"),
    target: () => queryTourTarget("unit-plan-table"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitPlanTable_Add_Title"),
    description: t("Tour_UnitPlanTable_Add_Description"),
    target: () => queryTourTarget("unit-plan-add"),
    placement: "left",
  },
];
